import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EngineAtomSearchSchema } from '../-shared/engine-atom-search-schema';

export const Route = createFileRoute(
  '/_staff/attendance-engine/_layout/attendance-units/',
)({
  validateSearch: zodValidator(EngineAtomSearchSchema),
});
